<template>
  <div id="app">
    <b-navbar toggleable="sm" type="dark" variant="dark">
      <b-navbar-brand href="https://www.autohome.com.cn" class="font-weight-bold">汽车之家</b-navbar-brand>
      <b-navbar-brand href="/" class="sub">WebCheck 客户网络检测</b-navbar-brand>
    </b-navbar>
    <router-view class="main container-lg"></router-view>
    <nav class="footer navbar-dark bg-dark">
      <div class="text-wrap text-center text-white-50 p-3">©2021 汽车之家 webcheck.autohome.com.cn</div>
    </nav>
  </div>
</template>

<script>

  export default {
    name: 'app-main',
    provide() {
      return {
        main: this
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sub {
    color: #dddde2;
    font-size: 0.9rem;
    font-weight: 500;
  }

  .footer {
    .text-wrap {
      font-size: 0.8rem;
    }
  }
</style>
